import { Routes, Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ListaReportPage from '../pages/ListaReport/page';
import VisualizzaDettaglioReport from '../pages/ListaReport/[key]/page';
import DynamicDriverPage, { DynamicDettaglioWrapper } from './DynamicDriverPage';
import RequireAuth from '../context/RequireAuth';
import RankingReportPage from '../pages/ListaReport/[key]/ranking/page';
import HomePage from '../pages/home/HomePage';
import BestExecutionHomePage from '../pages/BestExecution/BestExecutionHomePage';
import ConductRiskHomePage from '../pages/ConductRisk/ConductRiskHomePage';
import ConductRiskListaReportPage from '../pages/ConductRisk/ListaReport/page';
import ConductRiskDettaglioReportPage from '../pages/ConductRisk/ListaReport/[id]/page';
import ConductRiskDriverDetailPage from '../pages/ConductRisk/ListaReport/[id]/driver/[driverId]/page';
import BanksPage from '../pages/Banks/page';
import DettaglioBanca from '../pages/Banks/[key]/page';
import AltreFontiPage from '../pages/AltreFonti/page';

// import NotFound from '../pages/NotFound';

export { routesMap } from './routesMap';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={
          <RequireAuth>
            <HomePage />
          </RequireAuth>
        } />
        <Route path="/best-execution" element={
          <RequireAuth>
            <BestExecutionHomePage />
          </RequireAuth>
        } />
        <Route path="/conduct-risk" element={
          <RequireAuth>
            <ConductRiskHomePage />
          </RequireAuth>
        } />
        <Route path="/conduct-risk/report" element={
          <RequireAuth>
            <ConductRiskListaReportPage />
          </RequireAuth>
        } />
        <Route path="/conduct-risk/report/:name/visualizza-report" element={
          <RequireAuth>
            <ConductRiskDettaglioReportPage />
          </RequireAuth>
        } />
        <Route path="/conduct-risk/report/:name/visualizza-report/:driverSlug" element={
          <RequireAuth>
            <ConductRiskDriverDetailPage />
          </RequireAuth>
        } />
        <Route path="/best-execution/report" element={
          <RequireAuth>
            <ListaReportPage />
          </RequireAuth>
        } />
        <Route path="/best-execution/banks" element={
          <RequireAuth>
            <BanksPage />
          </RequireAuth>
        } />
        <Route path="/best-execution/altre-fonti" element={
          <RequireAuth>
            <AltreFontiPage />
          </RequireAuth>
        } />
        <Route path="/best-execution/report/:name/visualizza-report" element={
          <RequireAuth>
            <VisualizzaDettaglioReport />
          </RequireAuth>
        } />
        <Route path="/best-execution/banks/:name/visualizza-banca" element={
          <RequireAuth>
            <DettaglioBanca />
          </RequireAuth>
        } />
        <Route path="/best-execution/report/:name/visualizza-report/ranking" element={
          <RequireAuth>
            <RankingReportPage />
          </RequireAuth>
        } />
        <Route path="/best-execution/report/:name/visualizza-report/:driverRoute" element={
          <RequireAuth>
            <DynamicDriverPage />
          </RequireAuth>
        } />
        <Route path="/best-execution/report/:name/visualizza-report/:driverRoute/:intermediarioName" element={
          <RequireAuth>
            <DynamicDettaglioWrapper />
          </RequireAuth>
        } />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Route>
    </Routes>
  );
}
